import template from './item.create.html';
import controller from './item.create.controller';
import './item.create.controller';

let itemCreateComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default itemCreateComponent;



// WEBPACK FOOTER //
// ./client/app/components/item/create/item.create.component.js